import m from "../../geodata/es2015/djiboutiLow";
window.am4geodata_djiboutiLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/djiboutiLow.js
// module id = null
// module chunks = 